export default {
  hero: {
    title: '思棟株式会社について',
    subtitle: '革新的な技術、未来への力'
  },
  
  companyIntro: {
    title: '会社概要',
    paragraph1: '思棟株式会社は、アジア太平洋地域のITインフラサービスに特化した専門プロバイダーです。地域市場への深い洞察とグローバルな技術視点を活用し、企業のデジタル変革のための強固な技術基盤を築いています。過去20年間、世界的に有名な多くの企業に効率的で安全かつ信頼性の高いサービスを提供し続けてきました。',
    paragraph2: '当社のサービスネットワークは、アジア太平洋地域の主要商業センターをカバーしています。現地チームとグローバルリソースの組み合わせにより、多国籍企業や地域機関にシームレスな技術ソリューションを提供します。インフラ計画から実装・運用まで、思棟株式会社はお客様のデジタル変革の旅に全面的に寄り添います。'
  },
  
  missionVision: {
    title: '私たちのミッションとビジョン',
    mission: {
      title: 'ミッション',
      content: '革新的な技術と高品質なサービスを通じて、企業のデジタル変革を支援し、運用効率を向上させ、持続的なビジネス成長を推進します。'
    },
    vision: {
      title: 'ビジョン',
      content: 'アジア太平洋地域のITインフラ管理分野における信頼されるパートナーとなり、技術革新とサービス向上を通じて、お客様のインフラ近代化とビジネス成長の相乗効果の実現を支援します。'
    }
  },
  
  certifications: {
    title: '資格と認証',
    items: {
      iso9001: {
        name: 'ISO 9001',
        description: '品質管理システム認証'
      },
      iso27001: {
        name: 'ISO 27001',
        description: '情報セキュリティ管理認証'
      },
      idcIsp: {
        name: 'IDC/ISP',
        description: '中国本土データセンター資格'
      },
      imda: {
        name: 'IMDA',
        description: 'シンガポールIMDA認証'
      },
      microsoft: {
        name: 'マイクロソフトパートナー',
        description: 'ゴールド認定パートナー'
      },
      aws: {
        name: 'AWSパートナー',
        description: 'アドバンスドコンサルティングパートナー'
      },
      huawei: {
        name: 'ファーウェイクラウドパートナー',
        description: 'ソリューションパートナー'
      },
      award: {
        name: '業界優秀賞',
        description: 'アジア太平洋ITサービス革新賞'
      }
    }
  },
  
  serviceNetwork: {
    title: 'アジア太平洋サービスネットワーク',
    subtitle: 'ホームページのサービスマップと同じ 11 のアジア太平洋サービス地域をカバーし、ローカル IT インフラサービスと地域連携デリバリーを提供します',
    serviceScopeLabel: 'サービス範囲',
    regions: {
      china: {
        name: '中国本土',
        subtitle: '中国本土サービスセンター',
        offices: {
          shanghai: {
            title: '上海サービスセンター',
            address: 'Room 1003-1, Guangming Real Estate Building, No. 199 Xizang North Road, Jing\'an District, Shanghai, China / 中国上海市静安区西藏北路199号 光明地产大厦1003-1室'
          },
          beijing: {
            title: '北京サービスセンター',
            address: 'No. 18, Jingjia Road, Yanqi Town, Huairou District, Beijing, China / 北京市怀柔区雁栖镇京加路18号'
          },
          guangzhou: {
            title: '深圳サービスセンター',
            address: 'Unit 55, Room 1407, Building B, Phase 1, Tian\'an Innovation Technology Plaza, No. 4 Tairan Road, Futian District, Shenzhen, China / 深圳市福田区天安創新科技広場一期B座1407-55'
          }
        },
        serviceScope: '中国本土全域、データセンター建設と運用、クラウドコンピューティングソリューション、ネットワークセキュリティサービス、ITコンサルティングサービスを提供'
      },
      hongkong: {
        name: '香港',
        subtitle: '香港サービスセンター',
        offices: {
          hq: {
            title: '香港サービスセンター',
            address: 'Room A, 1/F., Arthur Commercial Building, 33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong / 香港九龍油麻地鴉打街33号雅達商業大廈1樓A室'
          }
        },
        serviceScope: '香港および国際ビジネス中継ハブ、国境を越えたデータセンター接続、国際ネットワークサービス、フィンテックソリューションを提供',
        highlight: {
          title: '国際ビジネスの優位性',
          content: '中国本土とグローバル市場を結ぶ橋として、低遅延の国境を越えたデータ転送と国際コンプライアンスコンサルティングサービスを提供'
        }
      },
      taiwan: {
        name: '台北',
        subtitle: '台北サービスセンター',
        offices: {
          taipei: {
            title: '台北サービスセンター',
            address: ''
          },
          hsinchu: {
            title: '新竹サービスセンター',
            address: ''
          }
        },
        serviceScope: '台湾地域全域、ハイテク製造業向けITソリューション、クラウドコンピューティングサービス、データセキュリティ管理に特化'
      },
      japan: {
        name: '日本',
        subtitle: '日本サービスセンター',
        offices: {
          tokyo: {
            title: '東京サービスセンター',
            address: '208, 2-9-17 HIGASHITABATA, KITA-KU, TOKYO 114-0013, JAPAN / 東京都北区東田端二丁目9番17-208号'
          },
          osaka: {
            title: '大阪サービスセンター',
            address: ''
          }
        },
        serviceScope: '日本全国、エンタープライズITインフラ管理、クラウド移行、日本語ローカライズ技術サポートサービスを提供'
      },
      korea: {
        name: '韓国',
        subtitle: '韓国サービスセンター',
        offices: {
          seoul: {
            title: 'ソウルサービスセンター',
            address: ''
          }
        },
        serviceScope: '韓国全域および周辺地域、企業のクラウド変革、データセンター近代化、韓国語技術サポートサービスに特化',
        highlight: {
          title: '技術的専門性',
          content: '半導体および電子製造業界のITソリューションにおいて豊富な経験と専門知識を保有'
        }
      },
      singapore: {
        name: 'シンガポール',
        subtitle: 'シンガポールサービスセンター',
        offices: {
          hq: {
            title: 'シンガポールサービスセンター',
            address: '10 ANSON ROAD #27-18 INTERNATIONAL PLAZA SINGAPORE (079903)'
          }
        },
        serviceScope: 'シンガポールおよび周辺東南アジア地域、地域ITインフラ管理、クラウドサービス、国境を越えたデータコンプライアンスソリューションを提供',
        highlight: {
          title: '地域的優位性',
          content: '東南アジアのビジネスハブとして、多言語サポートとASEANデータ保護規制に準拠したITソリューションを提供'
        }
      }
    }
  },
  
  cta: {
    title: '今すぐ製品を体験',
    description: '思棟株式会社は最先端の技術ソリューションを提供することに取り組んでいます。当社の製品は、数百の企業がデジタル変革を実現し、運用効率を向上させ、ビジネス成長を推進するのを支援してきました。',
    button: 'お問い合わせ'
  }
}
